import { useCallback, useEffect } from 'react'
import useQueryParams from '../../hooks/useQueryParams'
import {
  useCurrentCycle,
  useCycles,
  getPrevCycle,
} from '../../redux/slices/practices'
import {
    useIsAdmin,
} from '../../redux/slices/session'

import usePracticeCycles from '../Common/usePracticeCycles'
import { PAGE_SIZE } from '../../lib/constants'
import useLocalStorage from '../../hooks/useLocalStorage'

const QUERY_PARAMS_SCHEMA = {
  page: Number,
  perPage: Number,
  showInactive: Boolean,
}

export default function useFilters(initialValues = {}) {
  // eslint-disable-next-line no-unused-vars
  const [_, { practice, practiceId }] = usePracticeCycles()
  const [conditions, setConditions] = useQueryParams({
    initialValues,
    schema: QUERY_PARAMS_SCHEMA,
  })
  const cycles = useCycles(practiceId)
  const currentCycle = useCurrentCycle(practiceId)
  const { cycleId } = conditions
  const [localStoragePageSize] = useLocalStorage('pageSize', PAGE_SIZE)
  const pageSize = conditions.perPage || localStoragePageSize
  const isAdmin = useIsAdmin()


  useEffect(() => {
    if (practice && cycles.length && currentCycle && !cycleId) {
      const newCycleId = (
        ((practice.hospitalSystemWorkflow && !isAdmin) && getPrevCycle(cycles)) ||
        currentCycle
      ).id
      setConditions({ cycleId: newCycleId, page: 1, perPage: pageSize })
    }
  }, [isAdmin, cycleId, currentCycle, cycles, practice, setConditions, pageSize])

  const handleFilterChange = useCallback(
    args =>
      setConditions({
        ...conditions,
        cycleId: args.cycleId,
        page: 1,
        perPage: pageSize,
      }),
    [conditions, setConditions, pageSize],
  )

  const handlePageChange = useCallback(
    page => setConditions({ ...conditions, page }),
    [conditions, setConditions],
  )

  return {
    conditions,
    setConditions,
    handlePageChange,
    handleFilterChange,
  }
}
